// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qw-9";
export var arrowButtonContainer = "_qw-5";
export var arrowButtonIcon = "_qw-6";
export var carouselArrowButton = "_qw-2";
export var carouselElementContainer = "_qw-1";
export var currentSlide = "_qw-8";
export var left = "_qw-3";
export var otherSlide = "_qw-a";
export var productCarouselContainer = "_qw-0";
export var right = "_qw-4";
export var sliderOverflow = "_qw-7";